import { render } from "./WhatsappComponente.vue?vue&type=template&id=1cdc726c"
import script from "./WhatsappComponente.vue?vue&type=script&lang=js"
export * from "./WhatsappComponente.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__